// RenderTrackerService.ts
import { BehaviorSubject } from 'rxjs';

import { type ContextData } from './types/context-data.type';
import { type ContextMenuData } from './types/context-menu-data.type';
import { emptyContextData } from './helpers/empty-context-data';
import { emptyContextMenuData } from './helpers/empty-context-menu-data';

class ContextMenuService {
	private static instance: ContextMenuService;
	private data: ContextMenuData;
	private svg: null | SVGSVGElement;
	private contextFrozen: boolean;
	private subject = new BehaviorSubject<ContextMenuData>(emptyContextMenuData());

	private enabled = false;

	private constructor () {
		this.data = emptyContextMenuData();
		this.svg = null;
		this.contextFrozen = false;
	}

	static getInstance (): ContextMenuService {
		if (!ContextMenuService.instance) {
			ContextMenuService.instance = new ContextMenuService();
		}
		return ContextMenuService.instance;
	}

	setEnabled (enabled: boolean): void {
		this.enabled = enabled;
		if (!enabled) {
			this.reset();
		}
	}

	isEnabled (): boolean {
		// requires both svg and enabled flag set to be true
		return this.svg !== null && this.enabled;
	}

	getSvg (): null | SVGSVGElement {
		return this.svg;
	}
	setSvg (svg: null | SVGSVGElement): void {
		this.svg = svg;
	}

	setContext (context: ContextData): void {
		if (!this.enabled || this.contextFrozen) return;
		this.data.context = { ...emptyContextData(), ...context };
		this.subject.next({ ...this.data });
		// console.log('contextMenu.setContext', this.enabled, context.menuKey, context.element, context.refId);
	}

	setPosition (position: { x: number; y: number }): void {
		if (!this.enabled || this.contextFrozen) return;
		this.data.position = position;
		this.data.relative = {
			x: position.x - this.data.context.center.x,
			y: position.y - this.data.context.center.y
		};
		this.subject.next({ ...this.data });
	}

	freezeContext (freeze: boolean) {
		if (!this.enabled) return;
		this.contextFrozen = freeze;

		this.subject.next({ ...this.data });
	}

	getContext$ () {
		return this.subject.asObservable();
	}

	reset (): void {
		this.data = emptyContextMenuData();
		this.svg = null;
		this.contextFrozen = false;
		this.data.position = { x: 0, y: 0 };
		this.data.relative = { x: 0, y: 0 }

		this.subject.next(this.data);
	}
}

export const contextMenuService = ContextMenuService.getInstance();
